import React from 'react';

import './index.styles.scss';

export const MobileQADetail = () => {
  return <div>QA detail page</div>;
};
